import { createSlice, current } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios, endpoint } from '../../utils/axios';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  datas: [],
};

const slice = createSlice({
  name: 'translation',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET TRANSLATIONS
    getTranslations(state, action) {
      state.isLoading = false;
      state.datas = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { getKelasSuccess } = slice.actions;

// ----------------------------------------------------------------------

export function getTranslations() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(endpoint.translation.root, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      let data = response.data;
      dispatch(slice.actions.getTranslations(data));

      i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
          resources: {
            id: { translations: data?.id },
            en: { translations: data?.en },
            cn: { translations: data?.cn },
          },
          lng: localStorage.getItem('i18nextLng') || 'id',
          fallbackLng: 'en',
          debug: false,
          ns: ['translations'],
          defaultNS: 'translations',
          interpolation: {
            escapeValue: false,
          },
        });
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
